import { Controller } from "@hotwired/stimulus"

// Muestra un toast (toastr) en cuanto su elemento entra al DOM. Sirve para flash
// en respuestas turbo_stream: un <script> dentro del <template> de un turbo-stream
// NO se ejecuta, pero connect() SÍ corre cuando turbo-stream inserta el nodo. Se
// auto-remueve tras disparar para no acumular nodos vacíos en #notifications
// (toastr renderiza el toast en su propio #toast-container, no en este elemento).
export default class extends Controller {
  static values = { type: String, message: String, timeout: Number }

  connect() {
    const kind = { notice: "success", alert: "error", danger: "error", error: "error" }[this.typeValue] || "info"
    const timeout = this.hasTimeoutValue ? this.timeoutValue : 3000
    if (window.toastr && this.messageValue) {
      window.toastr[kind](this.messageValue, "", { timeOut: timeout, preventDuplicates: true })
    }
    this.element.remove()
  }
}
